import React, {FunctionComponent} from "react";
import FlexContent, {FlexContentDirection, FlexContentJustify, FlexContentSpacing} from "../flex-content/FlexContent";
import clsx from "clsx";

export type FormLayoutButtonsProps = {
    children: React.ReactNode;
    justify?: FlexContentJustify;
    noWrapReverse?: boolean;
};

const FormLayoutButtons: FunctionComponent<FormLayoutButtonsProps> = ({children, justify = FlexContentJustify.CENTER, noWrapReverse}) => {
    return (
        <FlexContent
            direction={FlexContentDirection.ROW}
            justify={justify}
            spacing={FlexContentSpacing.SMALL}
            cssClass={clsx("form-layout__buttons", {"form-layout__buttons--no-wrap-reverse": noWrapReverse})}
        >
            {children}
        </FlexContent>
    );
};

export default FormLayoutButtons;
